<template>
  <div>
    <h1 class="page-header">
      {{ $t('addministration.employee_feature.employee_profile') }}
    </h1>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-6">
            <ts-button
              color="info"
              outline
              @click="$router.push({ name: 'employee-profile-create' })"
            >
              {{ $t('addministration.employee_feature.add_new') }}
            </ts-button>
          </div>
          <div class="col-sm-6 d-flex justify-content-end">
            <ts-input
              v-model="search"
              :placeholder="$t('addministration.employee_feature.search')"
              style="width: 300px;"
              class="kh-font"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template slot-scope="{ record }">
          <td class="kh-font">{{ record.name_kh }}</td>
          <td>{{ record.name_en }}</td>
          <td>
            {{ record.division ? record.division.division_name_en : '' }}
          </td>
          <td>
            {{ record.department ? record.department.department_name_en : '' }}
          </td>
          <td>{{ $store.getters.limitStringShow(record.description) }}</td>
          <td class="text-center">
            <router-link
              :to="{
                name: 'employee-profile-edit',
                params: { id: record.employee_id }
              }"
              v-tooltip="$t('addministration.employee_feature.edit')"
              class="mr-3"
            >
              <i class="fas fa-edit"></i>
            </router-link>

            <a
              href="#"
              v-tooltip="$t('addministration.employee_feature.delete')"
              class="text-danger"
              @click="destroy(record.employee_id)"
            >
              <i class="fas fa-trash"></i>
            </a>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'

export default {
  name: 'employee-profile',
  data() {
    return {
      loading: false,
      columns: [
        {
          name: this.$t('addministration.employee_feature.name_kh'),
          style: 'width: 15%;'
        },
        {
          name: this.$t('addministration.employee_feature.name_en'),
          style: 'width: 15%;'
        },
        {
          name: this.$t('addministration.employee_feature.division'),
          style: 'width: 15%;'
        },
        {
          name: this.$t('addministration.employee_feature.department'),
          style: 'width: 15%;'
        },
        { name: this.$t('addministration.employee_feature.description') },
        {
          name: this.$t('addministration.employee_feature.action'),
          style: 'text-align:center; width: 1px;'
        }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('employeeProfile', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.employeeProfile.search
      },
      set(newValue) {
        this.$store.commit('employeeProfile/SET_SEARCH', newValue)
        this.$store.commit('employeeProfile/RESET_CURRENT_PAGE')
      }
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('employeeProfile/fetch', attributes)
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },

    async destroy(employee_id) {
      if (
        await this.$confirmModal.danger(
          this.$t('addministration.employee_feature.are_you_sure_to_delete')
        )
      ) {
        this.$store
          .dispatch('employeeProfile/destroy', employee_id)
          .then(response => {
            this.$toasted.success(response.message)
            this.fetchData()
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
      }
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'employee-profile-create') {
      this.$store.commit('employeeProfile/RESET_STATE')
    }
    next()
  }
}
</script>
